<template>
    <div v-if="loading" class="text-center">
        <b-spinner></b-spinner>
    </div>
    <div v-else>
        <validation-observer ref="observer" v-slot="{ passes }">
            <b-form @submit.prevent="submitForm" class="mt-4">
                <div>
                    <label for="name">Email:</label>
                    <validation-provider rules="required" v-slot="{ errors }">
                        <b-form-input v-model="email"></b-form-input>
                        <span v-show="errors[0]" class="error">{{ errors[0] }}</span>
                    </validation-provider>
                </div>
                <div>
                    <label for="credentials">App pasword:</label>
                    <validation-provider rules="required" v-slot="{ errors }">
                        <b-form-input v-model="password"></b-form-input>
                        <span v-show="errors[0]" class="error">{{ errors[0] }}</span>
                    </validation-provider>
                </div>
                <b-button type="submit" variant="success" class="mt-3">Create Channel</b-button>
            </b-form>
        </validation-observer>
    </div>
</template>

<script>
import {
    VueEditor
} from "vue2-editor";
import NotificationPop
    from "../mixins/NotificationPop";

export default {
    components: { VueEditor },
    mixins: [NotificationPop],
    data() {
        return {
            email: null,
            password: null,
            loading: false
        };
    },
    created() {

    },
    methods: {
        submitForm() {
            const formData = {
                type: 'imap_gmail',
                email: this.email,
                password: this.password
            };

            this.$http.post('/channels/new', formData)
                .then(response => {
                    // Handle the API response here
                    console.log(response.data);

                    // Perform router navigation
                    this.popNotification('Done refresh page', 'success')
                })
                .catch(error => {
                    this.popNotification('Cannot create channel. Please contact support', 'danger')
                    console.error('Error creating channel', error);
                });
        }
    },
};
</script>

<style scoped>
.b-form-group {
    margin-bottom: 1rem;
}
</style>
